import React, {useState} from "react"
import {NavigateFunction} from "react-router-dom"
import classNames from "classnames"
import Admonition from "../../Admonitions/Admonition"
import {BusinessApplication} from "../../../resources/application"
import CustomDropdown from "../../CustomDropdown/CustomDropdown"
import {BeneficialOwnerResource} from "../../../resources/beneficialOwner"
import {ConfirmationModal} from "../../ConfirmationModal/ConfirmationModal"
import {useEsc} from "../../../hooks/useEsc"

const officerContent = (application: BusinessApplication) => {
	return (
		<>
			{!application.attributes.publicTradedCompany &&
				application.attributes.officer &&
				`Officer - ${application.attributes.officer.fullName.first} ${application.attributes.officer.fullName.last}`}
		</>
	)
}

const boContent = (beneficialOwner: BeneficialOwnerResource) => {
	return (
		<>{`Beneficial Owner - ${beneficialOwner.attributes.fullName.first} ${beneficialOwner.attributes.fullName.last}`}</>
	)
}

const isSupportOfficerResubmit = true
const isSupportBeneficialOwnerResubmit = true
const isSupportBusinessResubmit = true

const maxEntitiesBeforeExpandingDropdown = 2

export default function ReevaluateApplicationChooseEntityModal(props: {
	close: () => void
	onSuccess: () => void
	application: BusinessApplication
	beneficialOwners?: BeneficialOwnerResource[]
	navigate: NavigateFunction
}) {
	const {close, application, navigate, beneficialOwners} = props

	const modalTitle = "You are about to resubmit this business application"

	const buttonText = "Edit Entity"

	const cancelButtonText = "Cancel"

	const warningMessage = (
		<p>
			You can choose one entity to edit and resubmit. Once that evaluation process ends you will be able to edit another
			entity.
		</p>
	)

	const businessEntityOption = {
		value: `/applications/${application.id}/resubmit`,
		key: `business`,
		content: <>Business</>,
	}

	const officerEntityOption = {
		value: `/applications/${application.id}/officer/resubmit`,
		key: `officer`,
		content: officerContent(application),
	}

	const boEntitiesOption =
		beneficialOwners?.map((bo) => {
			return {
				value: `/applications/${application.id}/beneficialOwner/${bo.id}/resubmit`,
				key: `bo-${bo.id}`,
				content: boContent(bo),
			}
		}) ?? []

	const businessEntityOptionList = isSupportBusinessResubmit ? [businessEntityOption] : []
	const officerEntityOptionList = isSupportOfficerResubmit ? [officerEntityOption] : []
	const boEntitiesOptionList = isSupportBeneficialOwnerResubmit ? boEntitiesOption : []

	const entitiesOptions = [...businessEntityOptionList, ...officerEntityOptionList, ...boEntitiesOptionList]

	const [navigationUrl, setNavigationUrl] = useState(businessEntityOption.value)

	useEsc(close)

	return (
		<ConfirmationModal
			close={close}
			onSubmit={() => {
				navigate(navigationUrl)
			}}
			okButtonText={buttonText}
			cancelButtonText={cancelButtonText}
			title={modalTitle}
			okButtonClassname={"button is-black mr-2"}
			cancelButtonClassname={"button is-white mr-2"}
		>
			<div className={"flex-container flex-dir-col gap-40"}>
				<label>Which entity would like to edit:</label>
				<CustomDropdown
					options={entitiesOptions}
					selectedValue={navigationUrl}
					onSelect={(val) => {
						setNavigationUrl(val)
					}}
					dropDownMenuClass={classNames(
						entitiesOptions.length > maxEntitiesBeforeExpandingDropdown
							? "reevaluate-application-choose-entity-modal"
							: "reevaluate-application-choose-entity-modal-multiple-selections"
					)}
				/>
				<Admonition type="is-warning" title="Attention" message={warningMessage} />
			</div>
		</ConfirmationModal>
	)
}
